// 중국어-광둥어(홍콩)
export default {
  LandingPage: {
    intro_sub: '為電視的包裝重新注入生命並為保護環境出一分力',
    title: '三星升級回收包裝',
    sequence1_1: '加入我們，通過將電視包裝重新製作成有用的物品',
    sequence1_2: '為可持續環境而減少浪費。 繼續向下滾動以邁出第一步',
    sequence2_1: '向您隆重介紹「三星升級回收包裝」',
    sequence2_2:
      '電視紙箱經專門設計，可進行升級改造，以幫助您保護環境。試試用電視紙箱製作各種家居用品吧!',
    sequence3_1: '遵循包裝上的印刷點',
    sequence3_2: `按照說明切開包裝，然後組裝以製作出精美的家品`,
    sequence4_1: '選擇要挑戰的家品',
    sequence4_2:
      '向下滾動並選擇您的電視紙箱。然後為您找到各種設計選項。現在，從您想要創建的項目開始您的旅程',
    selectBox: '選擇電产品',
    moreActivity: '三星永續發展活動的更多資訊',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/hk/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/hk/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/hk/sustainability/overview/',
    footer: '© 2019-2021 三星電子香港有限公司 版權所有',
    // <br/>
    // 使用Internet Explorer 11、Chrome、Firefox及較新版本之瀏覽器去瀏覽本網站的效果最佳。`
  },
  ProductPage: {
    selectDesign: '選擇要創作的設計',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: '電視控制台',
    StorageBox: '儲物盒',
    MagazineRack: '雜誌架',
    CatHouse: '貓屋',
    CatTunnel: '貓隧道',
    BookShelf: '書架',
    DeskShelf: '置物架',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: '文具',
    CoinBank: '存錢筒',
    MobileScanner:'智能手機掃描儀支架',
    TabletScanner:'流動平板掃描儀支架',
    PetStairs:'寵物樓梯',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: '分',
    all:'ALL',
    in: '英寸適用',
    inOnly: '英寸適用',
    allBoxSize: '所有紙箱尺寸',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: '說明',
    prepare: '準備紙箱',
    LetsDesign: '開始設計',
    drawParts: '在紙箱上畫出部件',
    note1: '請注意，圖形位置可能因國家／地區及尺寸而異',
    note2: '先畫出全部圖紙，使其適合紙箱',
    numberSpace: '數字=點之間的距離',
    diagonal: '對角線',
    LEFT: '左',
    RIGHT: '右',
    TOP: '頂部',
    TOP1: '頂部 1',
    TOP2: '頂部 2',
    BACK: '背部',
    MIDDLE: '中間',
    MIDDLE2: '中間 2',
    BOTTOM: '底部',
    FRONT: '前面',
    SIDE: '側面',
    secondSIDE: '另一側',
    secondSIDE1: '另一側 1',
    secondSIDE2: '另一側 2',
    LEG: '腳', //update
    JOINT: '接合', //update
    FACE: '正面', //update
    DRAWERBOTTOM: '抽屜底部', //update
    DRAWERSIDE: '抽屜側面', //update
    NOSE: '鼻翼', //update
    HANDLE: '手把', //update
    BOTTOMSIDE: '底部側面', //update
    TOPSIDE: '頂部側面', //update
    WING: '側翼', //update
    cutAndAssemble: '開始裁剪並組裝',
    beCareful: '請小心不要割傷自己',
    cutOutParts: '剪下所有部件',
    assemble: '組裝',
    Assemblyguide: '組裝指南', //update
    fold: '折疊例子',
    foldGuide: '折疊硬紙板時請使用家具的邊緣',
    foldGuideDezeen: '用摺疊工具沿著紙板上的虛線來回摺紙板', //update
    glue: '在表面均勻塗上膠水或膠帶', //update
    cable: '使用束帶或繩索連接', //update
    done: '完成！',
    goBack: '返回主功能選單',
  },
  CautionPage: {
    CAUTION: '注意',
    needItem: '您需要所有物品',
    children: '孩童需要成人陪伴',
    mat: '請在地板鋪上襯墊以防刮傷',
    doNotPutHeavyThing: '不要踩踏或坐在這些家具上，並儘量不要在上面放置重物',
    doNotThrow: '請不要將家具丟或踢向任何物體，包括人及動物',
    stayAwayFlame: '請遠離火源',
    stayAwayWater: '請勿靠近水或潮濕的地方',
    mayDamaged: '*電視機紙箱在運輸過程中可能已損壞',
    companyDoestResponsible: '*公司不承擔因此產生破損或損傷',
    cannotBeReturned:'',
    understand: '好的，我了解',
  },
  PrivacyPolicy: {
    title: '隱私政策',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1: '我們使用新的環保包裝加強永續承諾。',
      text2: '我們減少電視包裝的紙張及印刷，將其變成生活用品。',
      text2_special:'',
      text3: '選擇下面的按鈕了解更多資訊。',
    },
    greenIn: {
      title: '電視包裝走向綠色',
      subtitle1: '無印刷產品資訊',
      subtitle2: '升級環保包裝',
      desc: '搜尋型號名稱以獲取更多資訊',
      descM: '*Take a photo of the TV model number',
      guide: '型號名稱',
      button: 'Take Photo',
      button2: '前往製作物品',
    },
    search: {
      guide: 'Search..',
      noResult: '沒有結果',
      more: '更多',
    },
  },
  searchCountrySelect: '選擇要搜索的國家'
};
